import Header from './Header';
import Welcome from './Welcome';
import VideoTour from './VideoTour';
import PaymentPlan from './paymentPlan';
import Footer from './Footer';
import SalesTeam from './SalesTeam';
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { WhiteLabelCompanyConfig } from '../../reducers/whitelabelSlices';
import WhitelabelWelcome from '../whitelabelLanding';
import { isWhiteLabelEnvironment } from '../../utils/whiteLabelUtils';
import { applyWhiteLabelBranding, getStoredWhiteLabelConfig } from '../../utils/brandingUtils';
export const Login = () => {
  const storedWhiteLabelConfig = getStoredWhiteLabelConfig();
  const token = localStorage.getItem('token');
  const [logoUrl, setLogoUrl] = useState(storedWhiteLabelConfig?.logoUrl || '');
  const [configData, setConfigData] = useState(storedWhiteLabelConfig);
  const dispatch = useDispatch();

  const isWhiteLabel = isWhiteLabelEnvironment();

  const syncWhiteLabelConfig = (config) => {
    if (!config) return;

    applyWhiteLabelBranding(config);
    setLogoUrl(config?.logoUrl || '');
    setConfigData(config);
  };

  const fetchData = () => {
    const payload = {
      appBaseUrl: window.location.origin,
    };
    try {
      dispatch(WhiteLabelCompanyConfig(payload))
        .unwrap()
        .then(() => {
          syncWhiteLabelConfig(getStoredWhiteLabelConfig());
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } catch (error) {
      console.error('Dispatch Error:', error);
    }
  };

  useEffect(() => {
    syncWhiteLabelConfig(storedWhiteLabelConfig);
    fetchData();
  }, []);
  if (token) return <Navigate to={'/'} replace />;
  else
    return (
      <div className={` flex flex-column w-full`}>
        <Header logoUrl={logoUrl} />
        {!isWhiteLabel ? (
          <>
            <Welcome />
            <VideoTour />
            {/* <PaymentPlan /> */}
            <SalesTeam />
            <Footer />
          </>
        ) : (
          <WhitelabelWelcome data={configData} />
        )}
      </div>
    );
};
